import { useQuery } from "@tanstack/react-query";
// import { getCategoryWiseRevenue } from "../services/dashboard.service";
import dashboardServices from '../services/dashboard.service'


export const useCategoryWiseRevenue = ({
  startDate,
  endDate,
}) => {
  return useQuery({
    queryKey: [
      "category-wise-revenue",
      startDate,
      endDate,
    ],

    queryFn: () =>
      dashboardServices.getCategoryWiseRevenue({
        startDate,
        endDate,
      }),
  });
};